<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import { GET_VEHICLES_PAGINATED } from '@/services/api/master/fleet'
import { GET_SENSOR_PAGINATED } from '@/services/api/setting/sensor'
import { SENSOR_CODES } from './lib/sensors'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  apollo: {
    vehiclesPaginated: {
      query: GET_VEHICLES_PAGINATED,
      variables() {
        return {
          filter: {
            status: ['I', 'R'],
            pagination: {
              page: 1,
              show: 10,
            },
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.idleParkingCount = data.vehiclesPaginated.vehiclesPaginated.pagination.total
        }
      },
    },
    sensorsPaginated: {
      query: GET_SENSOR_PAGINATED,
      variables() {
        return {
          filter: {
            sensorCode: SENSOR_CODES.FUEL,
            pagination: {
              page: 1,
              show: 10,
            },
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.fuelSensorCount = data.sensorsPaginated.sensorsPaginated.pagination.total
        }
      },
    },
  },
  data() {
    return {
      idleParkingCount: 0,
      fuelSensorCount: 0,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    title() {
      return this.$t('setting.list.trackerSensor.trackerSensor')
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: { name: 'Setting' },
        },
        {
          text: this.$t('setting.list.trackerSensor.trackerSensor'),
        },
      ]
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbItems" hasBreadcrumb hasBackButton />
    <div class="mc-card__setting">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted" nav-wrapper-class="mc-tab">
          <b-tab v-if="hasAccess(['set_idle_parking:read'])" active class="border-0">
            <template #title>
              <span class="d-sm-inline-block">
                {{ $t('setting.list.trackerSensor.tracker') }}
              </span>
            </template>
            <b-row class="mc-card__list">
              <!-- Idle & Parking Limit Times -->
              <b-col v-if="hasAccess(['set_idle_parking:read'])" sm="12" md="4">
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item clearfix"
                  @click="$router.push({ name: 'Idle & Parking Limit Times' })"
                >
                  <div class="d-flex align-items-center">
                    <i class="mc-fa icon-outline_radio circle-icon-primary" />
                    <p class="text-sm-start fw-bold text-width-210 px-3">
                      {{ $t('setting.list.trackerSensor.idleParking') }}
                    </p>
                    <div class="item-width-100 item-right">
                      <h2 class="text-lg-center my-0 text-primary">
                        {{ idleParkingCount }}
                      </h2>
                      <p class="text-sm-center text-primary text-vehicle">
                        {{
                          idleParkingCount > 1
                            ? $t('global.text.vehicles')
                            : $t('global.text.vehicle')
                        }}
                      </p>
                    </div>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab v-if="hasAccess(['set_fuel:read'])" class="border-0">
            <template #title>
              <span class="d-sm-inline-block">
                {{ $t('setting.list.trackerSensor.sensor') }}
              </span>
            </template>
            <b-row class="mc-card__list">
              <!-- Fuel -->
              <b-col v-if="hasAccess(['set_fuel:read'])" sm="12" md="4">
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item clearfix"
                  @click="$router.push({ name: 'Fuel Sensor Setting' })"
                >
                  <div class="d-flex align-items-center">
                    <i class="mc-fa icon-outline_radio circle-icon-primary" />
                    <p class="text-sm-start fw-bold text-width-210 px-3">
                      {{ $t('setting.list.trackerSensor.fuel') }}
                    </p>
                    <div class="item-width-100 item-right">
                      <h2 class="text-lg-center my-0 text-primary">
                        {{ fuelSensorCount }}
                      </h2>
                      <p class="text-sm-center text-primary text-vehicle">
                        {{
                          fuelSensorCount > 1
                            ? $t('global.text.vehicles')
                            : $t('global.text.vehicle')
                        }}
                      </p>
                    </div>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
